import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'tools-icon',
  templateUrl: './tools-icon.component.html',
  styles: [':host { line-height: 0; }'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class ToolsIconComponent {}
